import { render, staticRenderFns } from "./ShoppingCartCheckoutInit-gt3.vue?vue&type=template&id=2fbc3b73&scoped=true"
import script from "./ShoppingCartCheckoutInit-gt3.vue?vue&type=script&lang=js"
export * from "./ShoppingCartCheckoutInit-gt3.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartCheckoutInit-gt3.vue?vue&type=style&index=0&id=2fbc3b73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc3b73",
  null
  
)

export default component.exports